<template>
  <section
    class="vn-order__container"
    :class="[{ 'vn-order__container--active': showProductsHolder }, { 'vn-order__container--hidden': isHidden }]"
    ref="floatLayer"
    @click="init()"
  >
    <div class="vn-order" @click.stop>
      <div class="vn-order__frame">
        <div class="vn-order__select" v-if="showProductsHolder">
          <input type="checkbox" id="select-prod" class="vn-order__trigger a11y" v-model="isOpenProductSelector" />
          <label for="select-prod" class="vn-order__holder" :class="{ 'vn-order__holder--active': isSelected }">
            {{ selectedProductTitle }} <i class="price" v-if="selectedProductPrice">{{ selectedProductPrice }} 원</i>
          </label>

          <ul class="vn-order__list">
            <li v-for="(product, index) in products" :key="index">
              <input
                type="radio"
                name="select-prod"
                :id="`select-prod-${index}`"
                class="vn-order__item a11y"
                @click="selectProduct(index)"
              />
              <label :for="`select-prod-${index}`" class="vn-order__item--label">
                {{ product.title }}
                <i class="vn-order__item--price">{{ renderPrice(product.salePrice) }} 원</i>
              </label>
            </li>
          </ul>
        </div>

        <div class="vn-order__prod">
          <!--todo: 7 일 이상이면 그레이톤-->
          <i class="vn-order__prod__label" v-if="promotionDDay">{{ promotionDDay }}</i>
          <h2 class="vn-order__prod__title">
            {{ promotionTitle }} <span class="sub">{{ promotionDescription }}</span>
          </h2>
        </div>

        <div class="vn-order__func">
          <input type="checkbox" id="select-switch" class="vn-order__switch a11y" v-model="canGoForward" />
          <label for="select-switch" class="vn-order__switcher btn btn--md btn--wide">수강권 선택하기</label>

          <button type="button" class="vn-order__btn btn btn--md btn--wide" @click="purchase" :disabled="!isSelected">
            {{ buttonLabel }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment';

export default {
  name: 'sheet',
  props: ['products', 'coursePage', 'buttonLabel'],
  computed: {
    isOnlyOne() {
      return this.products.length === 1;
    },
    isSelected() {
      return this.selectedIndex > -1;
    },
    showProductsHolder() {
      return this.canGoForward && this.canOpenProductHolder;
    },
    promotionDDay() {
      if (!this.coursePage.promotionBadgeAt) {
        return '';
      }
      const now = moment().startOf('day');
      const dDay = moment(this.coursePage.promotionBadgeAt).startOf('day').diff(now, 'days');
      if (dDay < 1) {
        return '오늘 마감';
      }
      if (dDay > 10) {
        return '';
      }
      return `D-${dDay}`;
    },
    promotionTitle() {
      return this.coursePage.promotionTitle || '';
    },
    promotionDescription() {
      return this.coursePage.promotionDescription || '';
    },
    selectedProductTitle() {
      return this.isSelected ? this.products[this.selectedIndex].title : '수강권을 선택하세요';
    },
    selectedProductPrice() {
      if (this.isSelected) {
        const { salePrice } = this.products[this.selectedIndex];
        return this.renderPrice(salePrice);
      } else {
        return false;
      }
    },
  },
  methods: {
    purchase() {
      const productId = this.products[this.selectedIndex].id;
      window.location.href = `/products/${productId}`;
    },
    renderPrice(salePrice) {
      const DEFAULT_PRICE = 9999999;
      return (Number(salePrice) || DEFAULT_PRICE).toLocaleString();
    },
    selectProduct(index) {
      if (this.selectedIndex !== index) return (this.selectedIndex = index);
    },
    init() {
      if (!this.isOnlyOne) {
        this.isOpenProductSelector = false;
        this.canOpenProductHolder = true;
        this.canGoForward = false;
      }
    },
    debounce(func, delay) {
      let timeId;

      return () => {
        clearTimeout(timeId);
        timeId = setTimeout(() => func(), delay);
      };
    },
  },
  watch: {
    selectedIndex(prev, next) {
      if (prev !== next) {
        this.isOpenProductSelector = !this.isOpenProductSelector;
      }
    },
  },
  created() {
    if (this.isOnlyOne) {
      this.selectedIndex = 0;
      this.canGoForward = true;
      this.canOpenProductHolder = false;
    }
  },
  mounted() {
    const { addEventListener, requestAnimationFrame, screen } = window;

    const watchingScroll = () => {
      const screenBottom = window.pageYOffset + screen.height;
      const footerTop = document.getElementById('footer').offsetTop;
      requestAnimationFrame(() => {
        this.isHidden = !!(screenBottom > footerTop);
      });
    };

    addEventListener('scroll', this.debounce(watchingScroll, 100));
    addEventListener('resize', this.debounce(watchingScroll, 500));
  },
  data() {
    return {
      isOpenProductSelector: false,
      canOpenProductHolder: true,
      canGoForward: false,
      selectedIndex: -1,
      isHidden: false,
    };
  },
};
</script>
